import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { FallbackProps, useErrorBoundary } from 'react-error-boundary';
import { LayoutContext } from '../contexts/layout-provider';

export const ErrorBoundaryFallback: React.FC<FallbackProps> = ({}) => {
  const { resetBoundary } = useErrorBoundary();

  const { setProfileWindow } = React.useContext(LayoutContext);

  return (
    <div
      className={
        'h-100 w-100 d-flex flex-column gap-2 justify-content-center align-items-center'
      }>
      <span>
        Oops, something didn’t load quite right. Want to try reloading the page?
      </span>
      <div className={'d-flex gap-2'}>
        <Button
          fillMode={'outline'}
          themeColor={'primary'}
          onClick={resetBoundary}>
          Reload
        </Button>
        <Button
          fillMode={'outline'}
          themeColor={'error'}
          onClick={() =>
            setProfileWindow({
              visible: true,
              activeTab: 'Support'
            })
          }>
          Report
        </Button>
      </div>
    </div>
  );
};
